module.exports = __webpack_public_path__ + "static/ordinace_008full-595de446d333d9ee6974895b60e9d0c3.jpg";